import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { IStatefulCellAdapter } from "../IStatefulCellAdapter";
import { StringAdapter } from "../StringAdapter";
import { ColumnDefinition } from "../../model/ColumnDefinition";
import { SysFeatures } from "../../model/core/SysFeatures";
import { SystemConfigPromiseService } from "shared/auth-services";
import { BfxSysConfigUtilService } from "shared/auth-services";

export const BMARK_DEFAULT_NAME = "BM";
// String types that are sortable as an Int32 in C++ module
export class OrderTypeAdapter extends StringAdapter {
  public bmarkShortNm: string;
  constructor(
    private _sysConfigService: SystemConfigPromiseService,
    private sysConfigUtilService?: BfxSysConfigUtilService,
  ) {
    super();

    this.getBmarkOrderDisplayName();
  }

  protected getValue({
    requestedOrderType,
    isInvertedOrderFg,
    executionType,
  }: CubiqTS.OrderDataImpl): string {
    switch (requestedOrderType) {
      case CubiqTS.RequestOrderType.BMARK:
        return this.bmarkShortNm;
      case CubiqTS.RequestOrderType.CALL:
        return executionType == CubiqTS.ExecutionType.MANUAL
          ? this.sysConfigUtilService.manualExecutionCallNameText
          : "CALL";
      case CubiqTS.RequestOrderType.SL_ASK:
        return "SL ASK";
      case CubiqTS.RequestOrderType.SL_ATRATE:
        return "SL";
      case CubiqTS.RequestOrderType.SL_BID:
        return "SL BID";
      case CubiqTS.RequestOrderType.TP:
        return "TP";
      case CubiqTS.RequestOrderType.TSL_ASK:
        return "TSL ASK";
      case CubiqTS.RequestOrderType.TSL:
        return "TSL";
      case CubiqTS.RequestOrderType.TSL_BID:
        return "TSL BID";
      case CubiqTS.RequestOrderType.MARKET:
        return "MKT";
    }
    return CubiqTS.RequestOrderType[requestedOrderType];
  }

  retrieveData(order: any, columnProperty: string): string {
    var orderType: any = order[columnProperty];
    if (orderType != undefined && orderType != null) {
      let retStr: string = this.retrieveSearch(order, columnProperty);
      switch (orderType) {
        case CubiqTS.RequestOrderType.BMARK:
          retStr = this.bmarkShortNm;
          break;
        case CubiqTS.RequestOrderType.SL_ASK:
        case CubiqTS.RequestOrderType.SL_ATRATE:
        case CubiqTS.RequestOrderType.SL_BID:
        case CubiqTS.RequestOrderType.TSL:
        case CubiqTS.RequestOrderType.TSL_ASK:
        case CubiqTS.RequestOrderType.TSL_BID:
          retStr = '<span class="order-type order-type-sl">' + retStr + "</span>";
          break;
        case CubiqTS.RequestOrderType.ALGO:
          retStr = order.algoStrategyName;
          break;
        default:
          break;
      }
      return retStr;
    }
    return "-";
  }

  retrieveSort(order: any, columnProperty: string): string {
    return this.retrieveSearch(order, columnProperty);
  }

  retrieveSearch(order: any, columnProperty: string): string {
    return this.getValue(order);
  }

  retrieveFilter(order: any, columnProperty: string): string {
    if (
      CubiqTS.RequestOrderType.ALGO === order[columnProperty] &&
      typeof order.algoStrategyName === "string"
    ) {
      return order.algoStrategyName;
    }

    return CubiqTS.RequestOrderType[order[columnProperty]];
  }

  async getBmarkOrderDisplayName() {
    this.bmarkShortNm = await this.getSystemConfig();
  }

  private getSystemConfig() {
    if (this._sysConfigService) {
      return new Promise<string>((res, rej) => {
        this._sysConfigService
          .getSystemConfig(SysFeatures.fixingOrderShortName)
          .then((value) => {
            let returnValue = value != null && value.length > 0 ? value : BMARK_DEFAULT_NAME;
            res(returnValue);
          })
          .catch((error) => {
            logger.out.error(`OrderTypeAdapter : getSystemConfig :
                        failed to get system config for: ${SysFeatures.fixingOrderShortName}`);
            rej(error.errorMessages);
          });
      });
    }
  }
}
